function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  "data-id": "left-circle",
  d: "M51.718 57.197A31.85 31.85 0 0132 64C14.339 64 0 49.661 0 32S14.339 0 32 0a31.85 31.85 0 0119.718 6.803C45.11 13.172 41 22.11 41 32c0 9.89 4.11 18.828 10.718 25.197z",
  fill: "#cc49e0"
});

var _ref2 =
/*#__PURE__*/
React.createElement("text", {
  "data-id": "org",
  x: 296,
  y: 150.402,
  fontFamily: "Open Sans",
  fontSize: 12,
  fill: "#f1f3f8",
  textAnchor: "middle",
  transform: "translate(-768.833 -362.252) scale(2.6987)"
}, "B");

var _ref3 =
/*#__PURE__*/
React.createElement("ellipse", {
  "data-id": "right-circle",
  cx: 83.5,
  cy: 26,
  rx: 11.5,
  ry: 13,
  fill: "#ade590",
  transform: "matrix(2.78261 0 0 2.46154 -156.348 -32)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("text", {
  "data-id": "user",
  x: 298.5,
  y: 150.402,
  fontFamily: "Open Sans",
  fontSize: 12,
  fill: "#f1f3f8",
  textAnchor: "middle",
  transform: "translate(-730.481 -363.706) scale(2.6987)"
}, "V");

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("image", {
  "data-id": "image-user",
  id: "template-org-and-user_svg___user",
  width: 200,
  height: 300,
  xlinkHref: "https://fastly.picsum.photos/id/230/200/200.jpg?hmac=8tI9ISupCMivMI7f7Q6i24FcYAg812XUEYJFZtaXp_8"
}), React.createElement("image", {
  "data-id": "image-org",
  id: "template-org-and-user_svg___organization",
  width: 200,
  height: 300,
  xlinkHref: "https://gravatar.com/avatar/f3c668ea59e5f83756eb711de9223ed1?s=200&d=robohash&r=x"
}));

var SvgTemplateOrgAndUser = function SvgTemplateOrgAndUser(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 108 64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgTemplateOrgAndUser;